export default "__VITE_ASSET__lI9Zx862__"